/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-action-menu-items-space: Specifies the space between actions in the menu.
*
*/
:host {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: var(--calcite-font-size-1);
}

::slotted(calcite-action-group:not(:last-of-type)) {
  border-block-end-width: var(--calcite-border-width-sm);
}

.default-trigger {
  position: relative;
  block-size: 100%;
  flex: 0 1 auto;
  align-self: stretch;
}

slot[name=trigger]::slotted(calcite-action),
calcite-action::slotted([slot=trigger]) {
  position: relative;
  block-size: 100%;
  flex: 0 1 auto;
  align-self: stretch;
}

.menu {
  display: flex;
  max-block-size: 45vh;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow-y: auto;
  overflow-x: hidden;
  outline: 2px solid transparent;
  outline-offset: 2px;
  gap: var(--calcite-action-menu-items-space, 0);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}